/** React */
import React, {
  Children,
  ComponentType,
  ReactNode,
  cloneElement,
  isValidElement,
  useMemo,
} from "react";

/** CSS */
import "./index.css";
import { MenuItem } from "./menu-item";

/** Props */
type MenuWrapperProps = {
  children: ReactNode;
};

const ALLOWED_CHILD_COMPONENT = [MenuItem.name];

export function MenuWrapper({ children }: MenuWrapperProps) {
  const menuItemComponents = useMemo(() => {
    return Children.map(children, (child) => {
      if (!isValidElement(child)) return;

      const childComponent = child.type as ComponentType;

      if (!ALLOWED_CHILD_COMPONENT.includes(childComponent.name)) return;

      return cloneElement(child);
    });
  }, [children]);

  return <div className="menu">{menuItemComponents}</div>;
}
